import { get } from 'svelte/store';
import { loginSessionStore } from './loginSessionStore';

export const getAccessToken = () => {
  const s = get(loginSessionStore);
  return s?.accessToken;
};
